import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vShow as _vShow, Transition as _Transition, withModifiers as _withModifiers, createBlock as _createBlock, mergeProps as _mergeProps, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0142c0ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "post d-flex flex-column-fluid",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-fluid px-0"
}
const _hoisted_3 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_4 = { class: "flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-350px mb-10 mb-lg-0" }
const _hoisted_5 = { class: "card card-one me-lg-5 mb-5 mb-lg-0" }
const _hoisted_6 = {
  class: "card-header px-5 py-4 bg-white",
  id: "kt_chat_contacts_header"
}
const _hoisted_7 = { class: "d-flex justify-content-between w-100" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = {
  class: "w-100 position-relative",
  autocomplete: "off"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-3 translate-middle-y" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "fw-bolder text-gray-900 text-hover-primary mb-2 pt-3 ms-5",
  role: "button",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  "data-kt-menu-target": `#vz-filter-data-smsFilters`
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-filter fs-1" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "position-absolute top-5 start-90 translate-middle badge badge-circle badge-cyan"
}
const _hoisted_15 = {
  class: "card-body py-5 px-0",
  id: "kt_chat_contacts_body"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "symbol symbol-45px symbol-circle" }
const _hoisted_19 = { class: "symbol-label bg-light-danger text-danger fs-6 fw-bolder" }
const _hoisted_20 = { class: "ms-5" }
const _hoisted_21 = { class: "fw-bolder text-gray-900 text-hover-primary mb-2 pointer-cursor" }
const _hoisted_22 = { class: "fw-bold text-muted" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed d-none" }, null, -1))
const _hoisted_24 = { class: "d-flex justify-content-between px-5 pt-3 card-footer position-sticky bg-white bottom-0" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "flex-lg-row-fluid" }
const _hoisted_27 = { class: "card card-one d-block" }
const _hoisted_28 = {
  class: "card-header",
  id: "kt_chat_messenger_header"
}
const _hoisted_29 = { class: "card-title d-flex align-items-center justify-content-between w-100" }
const _hoisted_30 = {
  id: "kt_customer_view_payment_method",
  class: "card-body px-8"
}
const _hoisted_31 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_32 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_33 = ["aria-expanded"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder fs-5" }, "Role")
  ])
], -1))
const _hoisted_37 = {
  id: "kt_role",
  class: "role-collapse fs-6"
}
const _hoisted_38 = { class: "card-body p-0 table-responsive" }
const _hoisted_39 = { class: "text-truncate" }
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "text-truncate" }
const _hoisted_42 = { class: "text-truncate" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1))
const _hoisted_47 = {
  id: "kt_customer_view_payment_method",
  class: "card-body pt-0 px-8 pb-0"
}
const _hoisted_48 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_49 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_50 = ["aria-expanded"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-3 rotate-90" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z",
        fill: "black"
      })
    ])
  ])
], -1))
const _hoisted_52 = { class: "me-3" }
const _hoisted_53 = { class: "d-flex align-items-center" }
const _hoisted_54 = { class: "text-gray-800 fw-bolder fs-5" }
const _hoisted_55 = { class: "card-body py-4 px-0 mx-n5 table-responsive" }
const _hoisted_56 = { class: "text-truncate" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-2" }, null, -1))
const _hoisted_62 = {
  id: "kt_customer_view_payment_method",
  class: "card-body pt-0 px-8"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-2" }, null, -1))
const _hoisted_64 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_65 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_66 = {
  class: "d-flex align-items-center collapsible collapsed rotate",
  "data-bs-toggle": "collapse",
  href: "#kt_custompermisson",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_custompermisson"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-3 rotate-90" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z",
        fill: "black"
      })
    ])
  ])
], -1))
const _hoisted_68 = { class: "me-3" }
const _hoisted_69 = { class: "d-flex align-items-center" }
const _hoisted_70 = { class: "text-gray-800 fw-bolder fs-5" }
const _hoisted_71 = {
  id: "kt_custompermisson",
  class: "collapse fs-6",
  "data-bs-parent": "#kt_custompermisson"
}
const _hoisted_72 = { class: "card-body py-4 px-0 mx-n3 table-responsive" }
const _hoisted_73 = { class: "text-truncate" }
const _hoisted_74 = { class: "text-truncate" }
const _hoisted_75 = {
  key: 0,
  class: "form-check form-switch me-10"
}
const _hoisted_76 = ["disabled", "id", "checked", "onClick"]
const _hoisted_77 = {
  key: 0,
  class: "form-check form-switch me-10"
}
const _hoisted_78 = ["disabled", "id", "checked", "onClick"]
const _hoisted_79 = {
  key: 0,
  class: "form-check form-switch me-10"
}
const _hoisted_80 = ["disabled", "id", "checked", "onClick"]
const _hoisted_81 = {
  key: 0,
  class: "form-check form-switch me-10"
}
const _hoisted_82 = ["disabled", "id", "checked", "onClick"]
const _hoisted_83 = ["onClick"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1))
const _hoisted_87 = {
  class: "modal fade",
  id: "kt_modal_assign_permission",
  ref: "hideModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_88 = { class: "modal-dialog modal-dialog-centered mw-850px" }
const _hoisted_89 = { class: "modal-content" }
const _hoisted_90 = {
  class: "modal-header",
  id: "kt_modal_assign_permission_header"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Assign Permission", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = { class: "modal-body scroll-y bg-light" }
const _hoisted_95 = {
  class: "d-flex flex-column scroll-y me-n7 pe-4",
  id: "kt_modal_assign_permission_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_assign_permission_header",
  "data-kt-scroll-wrappers": "#kt_modal_assign_permission_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { class: "form-label required" }
const _hoisted_98 = { class: "" }
const _hoisted_99 = { class: "fv-plugins-message-container text-start" }
const _hoisted_100 = { class: "fv-help-block" }
const _hoisted_101 = {
  key: 1,
  class: "position-relative align-items-center"
}
const _hoisted_102 = { class: "form-label required mt-4" }
const _hoisted_103 = { class: "" }
const _hoisted_104 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_105 = ["href", "aria-controls"]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-3 rotate-90" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z",
        fill: "black"
      })
    ])
  ])
], -1))
const _hoisted_107 = { class: "me-3" }
const _hoisted_108 = { class: "d-flex align-items-center" }
const _hoisted_109 = { class: "text-gray-800 fw-bolder" }
const _hoisted_110 = ["id", "data-bs-parent"]
const _hoisted_111 = { class: "w-100 py-5" }
const _hoisted_112 = {
  key: 0,
  class: "table-responsive mt-3"
}
const _hoisted_113 = { class: "table align-middle table-hover table-row-bordered fs-6 gy-3" }
const _hoisted_114 = { class: "text-start text-muted fw-bold text-uppercase gs-0" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "form-check form-switch mb-2" }
const _hoisted_117 = ["disabled", "id", "checked", "onClick"]
const _hoisted_118 = ["for"]
const _hoisted_119 = { key: 1 }
const _hoisted_120 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_121 = {
  type: "reset",
  id: "vz_add_edit_cancel",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
  "data-bs-dismiss": "modal"
}
const _hoisted_122 = ["data-kt-indicator"]
const _hoisted_123 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_124 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_125 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZFilter = _resolveComponent("VZFilter")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createElementVNode("input", {
                        onKeyup: _cache[0] || (_cache[0] = 
                        () => {
                          if (
                            _ctx.usersSearchTerm.length == 0 ||
                            _ctx.usersSearchTerm.length >= 3
                          )
                            _ctx.searchUsers();
                        }
                      ),
                        type: "text",
                        class: "form-control ps-13 mb-2 mb-sm-0",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.usersSearchTerm) = $event)),
                        name: "search",
                        placeholder: _ctx.t('common.search')
                      }, null, 40, _hoisted_11), [
                        [_vModelText, _ctx.usersSearchTerm]
                      ])
                    ])
                  ]),
                  _createVNode(_component_VZFilter, {
                    options: _ctx.tableFilter,
                    defaultFilter: {},
                    viewName: "userPermissionFilters",
                    onFilterChange: _ctx.onFilterChange
                  }, {
                    actions: _withCtx(() => [
                      (_ctx.tableFilter && _ctx.tableFilter.length)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_12, [
                            _hoisted_13,
                            (_ctx.activeFilter)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.activeFilter), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["options", "onFilterChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersFilter, (user, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["d-flex flex-stack p-5 pt-0 pointer-cursor", {
                      'bg-normal': user.webId !== _ctx.selectedUserId,
                      'bg-selected': user.webId == _ctx.selectedUserId,
                    }]),
                        onClick: ($event: any) => (_ctx.loadUserRoleData(user.webId, $event))
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(user?.firstName[0]?.toUpperCase()) + " " + _toDisplayString(user.lastName == null
                              ? ""
                              : user.lastName[0]?.toUpperCase()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(user.email), 1)
                          ])
                        ])
                      ], 10, _hoisted_16),
                      _hoisted_23
                    ], 64))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("select", {
                        name: "kt_customers_table_length",
                        class: "form-select form-select-sm",
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args))),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.usersPagination.rowsPerPage) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PAGE_ITEM, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item,
                            value: item
                          }, _toDisplayString(item), 9, _hoisted_25))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.usersPagination.rowsPerPage]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_pagination, {
                      "current-page": _ctx.usersPagination.page,
                      "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.usersPagination.page) = $event)),
                      onCurrentChange: _ctx.currentPageChange,
                      "page-size": _ctx.usersPagination.rowsPerPage,
                      layout: "prev, pager, next",
                      total: _ctx.usersPagination.total,
                      "hide-on-single-page": false,
                      "pager-count": 3,
                      background: ""
                    }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.selectUserName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", {
                      class: "d-flex align-items-center collapsible rotate",
                      role: "button",
                      "aria-expanded": _ctx.openRoleCollapse,
                      "aria-controls": "kt_role",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleRoleCollapse && _ctx.toggleRoleCollapse(...args)))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["me-3", {
                        'arrow-rotate-90': _ctx.openRoleCollapse,
                        'arrow-rotate-0': !_ctx.openRoleCollapse,
                      }])
                      }, _hoisted_35, 2),
                      _hoisted_36
                    ], 8, _hoisted_33)
                  ]),
                  _createVNode(_Transition, {
                    onBeforeEnter: _ctx.beforeEnter,
                    onEnter: _ctx.enter,
                    onAfterEnter: _ctx.afterEnter,
                    onBeforeLeave: _ctx.beforeLeave,
                    onLeave: _ctx.leave,
                    onAfterLeave: _ctx.afterLeave
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_Datatable, {
                            "table-data": _ctx.tableDataUserRoles,
                            "table-header": _ctx.tableHeaderUserRoles,
                            total: _ctx.userRolesPagination.total,
                            rowsPerPage: _ctx.userRolesPagination.rowsPerPage,
                            page: _ctx.userRolesPagination.page,
                            loading: _ctx.loadingUserRoles,
                            showSearch: _ctx.showSearchUserRoles,
                            defaultFilter: _ctx.defaultFilterUserRoles,
                            tableFilter: _ctx.tableFilterUserRoles,
                            bulkDelete: _ctx.bulkDeleteUserRoles,
                            tableForm: _ctx.roleFormData,
                            addButtonText: `${_ctx.t('pages.user.assignRole')}`,
                            viewName: "userRole",
                            onQueryUpdate: _ctx.queryUpdateUserRoles,
                            onFormSubmit: _ctx.submitUserRoles,
                            onBulkDelete: _ctx.onBulkDeleteUserRoleIds,
                            permissions: _ctx.permissionModel,
                            onTableRowClick: _ctx.tableRowClickUserRoles
                          }, {
                            "cell-siteName": _withCtx(({ row: userRole }) => [
                              _createElementVNode("span", _hoisted_39, _toDisplayString(userRole.siteName), 1)
                            ]),
                            "cell-userRoleName": _withCtx(({ row: userRole }) => [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge fw-bold m-1 text-wrap-custom", _ctx.getClass(userRole.roleName)]),
                                title: userRole.roleName
                              }, _toDisplayString(userRole.roleName), 11, _hoisted_40)
                            ]),
                            "cell-createdDate": _withCtx(({ row: userRole }) => [
                              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.format.DateTime(userRole.createdDate)), 1)
                            ]),
                            "cell-createdBy": _withCtx(({ row: userRole }) => [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(userRole.createdBy), 1)
                            ]),
                            "cell-actions": _withCtx(({ row: userRole }) => [
                              (_ctx.hasPermission(_ctx.permissionModel.delete))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.deleteUserRole(userRole)),
                                    class: "btn btn-icon btn-danger btn-circle btn-sm"
                                  }, _hoisted_45, 8, _hoisted_43))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "tableForm", "addButtonText", "onQueryUpdate", "onFormSubmit", "onBulkDelete", "permissions", "onTableRowClick"])
                        ])
                      ], 512), [
                        [_vShow, _ctx.openRoleCollapse]
                      ])
                    ]),
                    _: 1
                  }, 8, ["onBeforeEnter", "onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])
                ]),
                _hoisted_46
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex align-items-center collapsible rotate", {
                      collapsed: _ctx.openToggel === false,
                    }]),
                      "data-bs-toggle": "collapse",
                      href: "#kt_userpermisson",
                      role: "button",
                      "aria-expanded": _ctx.openToggel === true ? false : true,
                      "aria-controls": "kt_userpermisson"
                    }, [
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.t("common.permissions")), 1)
                        ])
                      ])
                    ], 10, _hoisted_50)
                  ]),
                  _createElementVNode("div", {
                    id: "kt_userpermisson",
                    class: _normalizeClass(["collapse fs-6", {
                    show: _ctx.openToggel === true,
                  }]),
                    "data-bs-parent": "#kt_userpermisson"
                  }, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_Datatable, {
                        "table-data": _ctx.tableDataUserPermissions,
                        "table-header": _ctx.tableHeaderUserPermissions,
                        total: _ctx.userPermissionsPagination.total,
                        rowsPerPage: _ctx.userPermissionsPagination.rowsPerPage,
                        page: _ctx.userPermissionsPagination.page,
                        loading: _ctx.loadingUserPermissions,
                        showSearch: _ctx.showSearchUserPermissions,
                        defaultFilter: _ctx.defaultFilterUserPermissions,
                        tableFilter: _ctx.tableFilterUserPermissions,
                        bulkDelete: _ctx.bulkDeleteUserPermissions,
                        viewName: "userPermissions",
                        onQueryUpdate: _ctx.queryUpdateUserPermissions,
                        permissions: _ctx.permissionModel
                      }, {
                        "cell-title": _withCtx(({ row: userPermissions }) => [
                          _createElementVNode("span", _hoisted_56, _toDisplayString(userPermissions.title == "Sites"
                            ? "Branches"
                            : userPermissions.title == "Sites Overview"
                            ? "Branch Overview"
                            : userPermissions.title == "Sms"
                            ? "Chat"
                            : userPermissions.title), 1)
                        ]),
                        "cell-read": _withCtx(({ row: userPermissions }) => [
                          _createElementVNode("span", {
                            class: "text-truncate",
                            innerHTML: _ctx.format.yesNoToIconPlain(userPermissions.read)
                          }, null, 8, _hoisted_57)
                        ]),
                        "cell-create": _withCtx(({ row: userPermissions }) => [
                          _createElementVNode("span", {
                            class: "text-truncate",
                            innerHTML: 
                            _ctx.format.yesNoToIconPlain(userPermissions.create)
                          
                          }, null, 8, _hoisted_58)
                        ]),
                        "cell-update": _withCtx(({ row: userPermissions }) => [
                          _createElementVNode("span", {
                            class: "text-truncate",
                            innerHTML: 
                            _ctx.format.yesNoToIconPlain(userPermissions.update)
                          
                          }, null, 8, _hoisted_59)
                        ]),
                        "cell-delete": _withCtx(({ row: userPermissions }) => [
                          _createElementVNode("span", {
                            class: "text-truncate",
                            innerHTML: 
                            _ctx.format.yesNoToIconPlain(userPermissions.delete)
                          
                          }, null, 8, _hoisted_60)
                        ]),
                        _: 1
                      }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "onQueryUpdate", "permissions"])
                    ])
                  ], 2)
                ]),
                _hoisted_61
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.t("pages.user.customPermissons")), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(_component_Datatable, {
                        "table-data": _ctx.tableDataRolePermissions,
                        "table-header": _ctx.tableHeaderRolePermissions,
                        total: _ctx.rolePermissionsPagination.total,
                        rowsPerPage: _ctx.rolePermissionsPagination.rowsPerPage,
                        page: _ctx.rolePermissionsPagination.page,
                        loading: _ctx.loadingRolePermissions,
                        showSearch: _ctx.showSearchRolePermissions,
                        defaultFilter: _ctx.defaultFilterRolePermissions,
                        tableFilter: _ctx.tableFilterRolePermissions,
                        tableForm: _ctx.formDataRolePermissions,
                        bulkDelete: _ctx.bulkDeleteCustomUser,
                        addButtonText: `${_ctx.t('pages.user.assignPermission')}`,
                        viewName: "customPermissions",
                        onQueryUpdate: _ctx.queryUpdateRolePermissions,
                        onFormSubmit: _ctx.submitRolePermissions,
                        onBulkDelete: _ctx.bulkDeleteCustomPermissionTabel,
                        permissions: _ctx.permissionModel,
                        customForm: true,
                        onCustomForm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.customForm()))
                      }, {
                        "cell-siteName": _withCtx(({ row: rolePermissions }) => [
                          _createElementVNode("span", _hoisted_73, _toDisplayString(rolePermissions.siteName), 1)
                        ]),
                        "cell-title": _withCtx(({ row: rolePermissions }) => [
                          _createElementVNode("span", _hoisted_74, _toDisplayString(rolePermissions.title), 1)
                        ]),
                        "cell-read": _withCtx(({ row: rolePermissions }) => [
                          (
                            _ctx.checkPermission('READ', rolePermissions.permissions)
                          )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                _createElementVNode("input", {
                                  disabled: 
                              !_ctx.hasPermission(
                                'VYZOR:USERS:USER PERMISSIONS:UPDATE'
                              ) ||
                              _ctx.checkIfPermissionExistsInRole(
                                rolePermissions.permissions.filter((obj) =>
                                  obj.permission_code.endsWith('READ')
                                )[0],
                                rolePermissions
                              )
                            ,
                                  class: _normalizeClass(["form-check-input", {
                              'form-input-unchecked': !_ctx.isChecked(
                                'READ',
                                rolePermissions.permissions
                              ),
                            }]),
                                  type: "checkbox",
                                  id: `rolePermission_Read${rolePermissions.webId}`,
                                  checked: 
                              _ctx.isChecked('READ', rolePermissions.permissions) ||
                              _ctx.checkIfPermissionExistsInRole(
                                rolePermissions.permissions.filter((obj) =>
                                  obj.permission_code.endsWith('READ')
                                )[0],
                                rolePermissions
                              )
                            ,
                                  onClick: ($event: any) => (_ctx.updatePermission('READ', rolePermissions))
                                }, null, 10, _hoisted_76)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        "cell-create": _withCtx(({ row: rolePermissions }) => [
                          (
                            _ctx.checkPermission(
                              'CREATE',
                              rolePermissions.permissions
                            )
                          )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                _createElementVNode("input", {
                                  disabled: 
                              !_ctx.hasPermission(
                                'VYZOR:USERS:USER PERMISSIONS:UPDATE'
                              ) ||
                              _ctx.checkIfPermissionExistsInRole(
                                rolePermissions.permissions.filter((obj) =>
                                  obj.permission_code.endsWith('CREATE')
                                )[0],
                                rolePermissions
                              )
                            ,
                                  class: _normalizeClass(["form-check-input", {
                              'form-input-unchecked': !_ctx.isChecked(
                                'CREATE',
                                rolePermissions.permissions
                              ),
                            }]),
                                  type: "checkbox",
                                  id: `rolePermission_Create${rolePermissions.webId}`,
                                  checked: 
                              _ctx.isChecked(
                                'CREATE',
                                rolePermissions.permissions
                              ) ||
                              _ctx.checkIfPermissionExistsInRole(
                                rolePermissions.permissions.filter((obj) =>
                                  obj.permission_code.endsWith('CREATE')
                                )[0],
                                rolePermissions
                              )
                            ,
                                  onClick: ($event: any) => (_ctx.updatePermission('CREATE', rolePermissions))
                                }, null, 10, _hoisted_78)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        "cell-update": _withCtx(({ row: rolePermissions }) => [
                          (
                            _ctx.checkPermission(
                              'UPDATE',
                              rolePermissions.permissions
                            )
                          )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                _createElementVNode("input", {
                                  disabled: 
                              !_ctx.hasPermission(
                                'VYZOR:USERS:USER PERMISSIONS:UPDATE'
                              ) ||
                              _ctx.checkIfPermissionExistsInRole(
                                rolePermissions.permissions.filter((obj) =>
                                  obj.permission_code.endsWith('UPDATE')
                                )[0],
                                rolePermissions
                              )
                            ,
                                  class: _normalizeClass(["form-check-input", {
                              'form-input-unchecked': !_ctx.isChecked(
                                'UPDATE',
                                rolePermissions.permissions
                              ),
                            }]),
                                  type: "checkbox",
                                  id: `rolePermission_Update${rolePermissions.webId}`,
                                  checked: 
                              _ctx.isChecked(
                                'UPDATE',
                                rolePermissions.permissions
                              ) ||
                              _ctx.checkIfPermissionExistsInRole(
                                rolePermissions.permissions.filter((obj) =>
                                  obj.permission_code.endsWith('UPDATE')
                                )[0],
                                rolePermissions
                              )
                            ,
                                  onClick: ($event: any) => (_ctx.updatePermission('UPDATE', rolePermissions))
                                }, null, 10, _hoisted_80)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        "cell-delete": _withCtx(({ row: rolePermissions }) => [
                          (
                            _ctx.checkPermission(
                              'DELETE',
                              rolePermissions.permissions
                            )
                          )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                _createElementVNode("input", {
                                  disabled: 
                              !_ctx.hasPermission(
                                'VYZOR:USERS:USER PERMISSIONS:UPDATE'
                              ) ||
                              _ctx.checkIfPermissionExistsInRole(
                                rolePermissions.permissions.filter((obj) =>
                                  obj.permission_code.endsWith('DELETE')
                                )[0],
                                rolePermissions
                              )
                            ,
                                  class: _normalizeClass(["form-check-input", {
                              'form-input-unchecked': !_ctx.isChecked(
                                'DELETE',
                                rolePermissions.permissions
                              ),
                            }]),
                                  type: "checkbox",
                                  id: `rolePermission_Delete${rolePermissions.webId}`,
                                  checked: 
                              _ctx.isChecked(
                                'DELETE',
                                rolePermissions.permissions
                              ) ||
                              _ctx.checkIfPermissionExistsInRole(
                                rolePermissions.permissions.filter((obj) =>
                                  obj.permission_code.endsWith('DELETE')
                                )[0],
                                rolePermissions
                              )
                            ,
                                  onClick: ($event: any) => (_ctx.updatePermission('DELETE', rolePermissions))
                                }, null, 10, _hoisted_82)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        "cell-actions": _withCtx(({ row: rolePermissions }) => [
                          (_ctx.hasPermission(_ctx.permissionModel.delete))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.deleteUserPermission(rolePermissions)),
                                class: "btn btn-icon btn-danger btn-circle btn-sm"
                              }, _hoisted_85, 8, _hoisted_83))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "tableForm", "bulkDelete", "addButtonText", "onQueryUpdate", "onFormSubmit", "onBulkDelete", "permissions"])
                    ])
                  ])
                ]),
                _hoisted_86,
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createVNode(_component_Form, {
                        id: "kt_modal_assign_permission_form",
                        onSubmit: _ctx.submitRolePermissions,
                        ref: "formRef",
                        class: "form",
                        "validation-schema": _ctx.formData.validationSchema
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_90, [
                            _hoisted_91,
                            _createElementVNode("div", {
                              class: "btn btn-sm btn-icon btn-active-color-primary",
                              "data-bs-dismiss": "modal",
                              onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)), ["stop"]))
                            }, _hoisted_93)
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("div", _hoisted_95, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.model, (element, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "col-md-12 fv-row mt-0"
                                }, [
                                  (element.type === 'list')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                        _createElementVNode("label", _hoisted_97, _toDisplayString(element.label), 1),
                                        _createElementVNode("div", _hoisted_98, [
                                          _createVNode(_component_Field, {
                                            name: element.name
                                          }, {
                                            default: _withCtx(({ field }) => [
                                              _createVNode(_component_el_select, _mergeProps(field, {
                                                modelValue: 
                                        _ctx.targetDataUserPermission[element.name]
                                      ,
                                                "onUpdate:modelValue": ($event: any) => ((
                                        _ctx.targetDataUserPermission[element.name]
                                      ) = $event),
                                                filterable: true,
                                                onChange: _ctx.siteUpdated,
                                                placeholder: element.placeholder
                                              }), {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataUserRoles, (option, index) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: index,
                                                      label: option.siteName,
                                                      value: option.siteId
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1040, ["modelValue", "onUpdate:modelValue", "onChange", "placeholder"])
                                            ]),
                                            _: 2
                                          }, 1032, ["name"]),
                                          _createElementVNode("div", _hoisted_99, [
                                            _createElementVNode("div", _hoisted_100, [
                                              _createVNode(_component_ErrorMessage, {
                                                name: element.name
                                              }, null, 8, ["name"])
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (
                                  element.type === 'custom' &&
                                  _ctx.selectedSiteId != null &&
                                  _ctx.selectedSiteId != undefined
                                )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                        _createElementVNode("label", _hoisted_102, _toDisplayString(element.label), 1),
                                        _createElementVNode("div", _hoisted_103, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionGroups, (perm, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: i,
                                              class: "p-1 mb-2 bg-white",
                                              "data-kt-customer-payment-method": "row"
                                            }, [
                                              _createElementVNode("div", _hoisted_104, [
                                                _createElementVNode("div", {
                                                  class: "d-flex align-items-center collapsible collapsed rotate",
                                                  "data-bs-toggle": "collapse",
                                                  href: `#kt_${i}`,
                                                  role: "button",
                                                  "aria-expanded": "false",
                                                  "aria-controls": `kt_${perm.title}`
                                                }, [
                                                  _hoisted_106,
                                                  _createElementVNode("div", _hoisted_107, [
                                                    _createElementVNode("div", _hoisted_108, [
                                                      _createElementVNode("div", _hoisted_109, _toDisplayString(perm.title), 1)
                                                    ])
                                                  ])
                                                ], 8, _hoisted_105)
                                              ]),
                                              _createElementVNode("div", {
                                                id: `kt_${i}`,
                                                class: "collapse fs-6 ps-5",
                                                "data-bs-parent": `#kt_${i}`
                                              }, [
                                                _createElementVNode("div", _hoisted_111, [
                                                  (
                                              _ctx.customPermisionsList.length > 0
                                            )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                                        _createElementVNode("table", _hoisted_113, [
                                                          _createElementVNode("thead", null, [
                                                            _createElementVNode("tr", _hoisted_114, [
                                                              _createElementVNode("th", null, _toDisplayString(_ctx.t(
                                                        "pages.user.permissions"
                                                      )), 1),
                                                              _createElementVNode("th", null, _toDisplayString(_ctx.t("read")), 1),
                                                              _createElementVNode("th", null, _toDisplayString(_ctx.t("create")), 1),
                                                              _createElementVNode("th", null, _toDisplayString(_ctx.t("update")), 1),
                                                              _createElementVNode("th", null, _toDisplayString(_ctx.t("delete")), 1)
                                                            ])
                                                          ]),
                                                          _createElementVNode("tbody", null, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(perm.childPermissions, (childPerm) => {
                                                              return (_openBlock(), _createElementBlock("tr", {
                                                                key: childPerm.id
                                                              }, [
                                                                _createElementVNode("td", null, _toDisplayString(childPerm.title ==
                                                        "Sites"
                                                          ? "Branches"
                                                          : childPerm.title ==
                                                            "Sites Overview"
                                                          ? "Branch Overview"
                                                          : childPerm.title ==
                                                            "Sms"
                                                          ? "Chat"
                                                          : childPerm.title), 1),
                                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                                                        0, 1, 2, 3,
                                                      ], (sequence) => {
                                                                  return _createElementVNode("td", { key: sequence }, [
                                                                    (
                                                            childPerm.permissions.some(
                                                              (permis) =>
                                                                permis.sequence ===
                                                                sequence
                                                            )
                                                          )
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                                          _createElementVNode("div", _hoisted_116, [
                                                                            _createElementVNode("input", {
                                                                              disabled: 
                                                                _ctx.getSpecificPermissionFromList(
                                                                  _ctx.getPermissionBySequence(
                                                                    childPerm.permissions,
                                                                    sequence
                                                                  )
                                                                )
                                                              ,
                                                                              type: "checkbox",
                                                                              class: _normalizeClass(["form-check-input", {
                                                                'form-input-unchecked':
                                                                  !_ctx.getSpecificPermissionFromList(
                                                                    _ctx.getPermissionBySequence(
                                                                      childPerm.permissions,
                                                                      sequence
                                                                    )
                                                                  ),
                                                              }]),
                                                                              id: `formSwitch_${
                                                                _ctx.getPermissionBySequence(
                                                                  childPerm.permissions,
                                                                  sequence
                                                                ).webId
                                                              }`,
                                                                              checked: 
                                                                _ctx.getSpecificPermissionFromCustomList(
                                                                  _ctx.getPermissionBySequence(
                                                                    childPerm.permissions,
                                                                    sequence
                                                                  )
                                                                ) ||
                                                                _ctx.getSpecificPermissionFromList(
                                                                  _ctx.getPermissionBySequence(
                                                                    childPerm.permissions,
                                                                    sequence
                                                                  )
                                                                )
                                                              ,
                                                                              onClick: ($event: any) => (
                                                                _ctx.updatePermissionForRole(
                                                                  _ctx.getPermissionBySequence(
                                                                    childPerm.permissions,
                                                                    sequence
                                                                  ).webId,
                                                                  this
                                                                )
                                                              )
                                                                            }, null, 10, _hoisted_117),
                                                                            _createElementVNode("label", {
                                                                              class: "form-check-label",
                                                                              for: `formSwitch_${
                                                                _ctx.getPermissionBySequence(
                                                                  childPerm.permissions,
                                                                  sequence
                                                                ).webId
                                                              }`
                                                                            }, null, 8, _hoisted_118)
                                                                          ])
                                                                        ]))
                                                                      : (_openBlock(), _createElementBlock("div", _hoisted_119))
                                                                  ])
                                                                }), 64))
                                                              ]))
                                                            }), 128))
                                                          ])
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ], 8, _hoisted_110)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("button", _hoisted_121, _toDisplayString(_ctx.t("common.close")), 1),
                            _createElementVNode("button", {
                              "data-kt-indicator": _ctx.loading ? 'on' : null,
                              class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                              type: "submit"
                            }, [
                              (!_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_123, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("common.save")), 1),
                                    _createElementVNode("span", _hoisted_124, [
                                      _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_125, [
                                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                                    _hoisted_126
                                  ]))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_122)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onSubmit", "validation-schema"])
                    ])
                  ])
                ], 512)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 0,
          showDialog: _ctx.showDeleteDialogUserRole,
          viewName: "userRole",
          selectedForAction: [_ctx.selectedForActionUserRoles.webId],
          deleteText: `${_ctx.t('validation.sureToDelete')} user ${
      _ctx.selectedForActionUserRoles.name
    }'s role ${_ctx.selectedForActionUserRoles.roleName} from branch ${
      _ctx.selectedForActionUserRoles.siteName
    }?`,
          onClose: _cache[8] || (_cache[8] = 
      () => {
        _ctx.showDeleteDialogUserRole = false;
        _ctx.refreshListUserRoles();
      }
    ),
          onBulkDelete: _cache[9] || (_cache[9] = 
      (data) => {
        _ctx.onBulkDeleteUserRoleIds(data);
        _ctx.showDeleteDialogUserRole = false;
      }
    )
        }, null, 8, ["showDialog", "selectedForAction", "deleteText"]))
      : _createCommentVNode("", true),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 1,
          showDialog: _ctx.showDeleteDialogUserPermission,
          viewName: "userPermissions",
          selectedForAction: _ctx.selectedUserPermissions,
          pageName: "custom permission",
          deleteText: `${_ctx.t('validation.sureToDelete')} '${
      _ctx.selectedForActionUserPermissions.title
    }' permissions for branch '${
      _ctx.selectedForActionUserPermissions.siteName
    }' for ${_ctx.selectedForActionUserPermissions.firstName} ${
      _ctx.selectedForActionUserPermissions.lastName
    }?`,
          onClose: _cache[10] || (_cache[10] = 
      () => {
        _ctx.showDeleteDialogUserPermission = false;
        _ctx.refreshListRolePermissions();
      }
    )
        }, null, 8, ["showDialog", "selectedForAction", "deleteText"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "las la-user-lock fs-3",
      viewName: "User Permissions Activity Pulse",
      type: "2300"
    }, null, 8, ["refresh"])
  ], 64))
}